import { find } from 'lodash'

export default {
  successLogin (state, data) {
    state.auth = true
    state.user = data.user
    if (data.default_user) {
      state.default_user = data.default_user
    } else if (!data.default_user && state.default_user) {
      state.default_user = null
    }
    state.entities = data.entities
    state.languages = data.languages || [
      'RU',
      'EN',
      'EN-AU',
      'EN-CA',
      'EN-NZ',
      'DE',
      'SE',
      'PL',
      'FR',
      'JA',
      'NO',
      'FI',
      'CA',
      'PT',
      'BR',
      'PT-BR',
      'NZ',
      'IT',
      'AU',
      'UZ',
      'GR',
      'EL-GR',
      'CH',
      'AT',
      'NL',
      'VI',
      'EN-MY',
      'ES',
      'DA-DK'
    ]
    state.currencies = data.currencies || []
    state.cms_upload = data.cms_upload || {}

    state.getEntityByLogin = function (login) {
      if (!login || typeof login !== 'string') {
        return {}
      }
      return find(this.entities, function (o) {
        let regex = new RegExp('^' + o.prefix)
        return login.match(regex)
      }) || {}
    }
    state.getEntityByEntityID = function (entity_id) {
      return find(this.entities, { entity_id })
    }
  },
  failLogin (state) {
    state.auth = false
    state.user = null
    state.recentViews = []
    state.entities = []
    clearTimeout(state.heartbeatTimeoutHandle)
    state.heartbeatTimeoutHandle = null
  },
  setHeartbeatTimeoutHandle(state, handleId) {
    if (!handleId) {
      clearTimeout(state.heartbeatTimeoutHandle)
    }
    state.heartbeatTimeoutHandle = handleId
  },
  logout (state) {
    state.auth = false
    state.user = null
    state.recentViews = []
    state.entities = []
  },
  recentViewLoad (state, list) {
    state.recentViews = (list || []).concat(state.recentViews || []).slice(0, 10)
  }
}
